import React from 'react';
import i18next from 'i18next';
import classNames from 'classnames';

export default class ProviderSelect extends React.PureComponent {
  static defaultProps = {
    activeProvider: 'sberbank',
    onSelect: () => {},
  };

  constructor(props) {
    super(props);

    this.providers = [
      {
        name: 'sberbank',
        logo: `${app.assetsPath}/images/sber.png`,
        title: i18next.t('providers.sberbank'),
      },
      {
        name: 'fk_ru',
        logo: `${app.assetsPath}/images/fk_ru.png`,
        title: i18next.t('providers.fk_ru'),
        style: {
          width: '80px',
          height: 'auto',
        },
      },
      {
        name: 'qiwi',
        logo: `${app.assetsPath}/images/qiwi.png`,
        title: i18next.t('providers.qiwi'),
      },
      {
        name: 'yandex_money',
        logo: `${app.assetsPath}/images/yandex_money.png`,
        title: i18next.t('providers.yandex_money'),
      },
      {
        name: 'visa_mastercard_ru',
        logo: `${app.assetsPath}/images/visa-mastercard.png`,
        title: i18next.t('providers.visa_mastercard_ru'),
        style: {
          width: '80px',
          height: 'auto',
        },
      },
      {
        name: 'visa_mastercard_ua',
        logo: `${app.assetsPath}/images/visa-mastercard.png`,
        title: i18next.t('providers.visa_mastercard_ua'),
        style: {
          width: '80px',
          height: 'auto',
        },
      },
      {
        name: 'webmoney_wmz',
        logo: `${app.assetsPath}/images/webmoney.png`,
        title: i18next.t('providers.webmoney_wmz'),
      },

    ];
  }

  render() {
    const { activeProvider, onSelect } = this.props;

    return (
      <div className="provider-select">
        {this.providers.map((provider) => {
          const providerClasses = classNames(
            'provider-select__item',
            `provider-select__item--${provider.name}`,
            { active: provider.name === activeProvider }
          );
          return (
            <div
              className={providerClasses}
              key={provider.name}
              onClick={onSelect.bind(null, provider.name)}
            >
              <img
                src={provider.logo}
                className="provider-select__logo"
                style={provider.style ? provider.style : {}}
              />
              {provider.title}
            </div>
          );
        })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/ProviderSelect/ProviderSelect.jsx